const clsOpen = "is-open";
const singleMode = true;

const toggleAccordionItem = (event, triggers, targets) => {
    const targetItem = event.currentTarget.parentElement;
    const targetMenu = event.currentTarget.nextElementSibling;

    if (targetItem.classList.contains(clsOpen)) {
        targetItem.classList.remove(clsOpen);
        targetMenu.style.height = 0;
        return false;
    }

    if (singleMode) {
        triggers.forEach((trigger) => {
            trigger.parentElement.classList.remove(clsOpen);
        });

        targets.forEach((target) => {
            target.style.height = 0;
        });
    }

    targetItem.classList.add(clsOpen);
    targetMenu.style.height = 'auto';
};

const Accordion = () => {
    const containers = document.querySelectorAll("[data-accordion]");
    if (containers.length === 0) {
        return;
    }

    containers.forEach((container) => {
        const triggers = container.querySelectorAll("[data-accordion-heading]");
        const targets = container.querySelectorAll("[data-accordion-body]");

        targets.forEach((target) => {
            target.style.height = 0;
            target.classList.add("overflow-hidden");
        });

        triggers.forEach((trigger) => {
            trigger.addEventListener("click", (event) => {
                toggleAccordionItem(event, triggers, targets);
            });
        });
    });
};

export default Accordion;
